import { VuexModule, Module, Mutation } from 'vuex-module-decorators';
import Store from '@/store/index';

@Module({
  dynamic: true,
  store: Store,
  name: 'drug_group',
  namespaced: true,
})
export default class DrugGroup extends VuexModule {
  cachedDrugGroups: { [key: string]: any } = {};

  @Mutation
  flushCachedById(id: string) {
    const changed = { ...this.cachedDrugGroups }
    delete changed[id];
    this.cachedDrugGroups = changed;
  }

  @Mutation
  flushAll() {
    this.cachedDrugGroups = {};
  }

  @Mutation
  cacheOne(item: any) {
    this.cachedDrugGroups = {
      ...this.cachedDrugGroups,
      [item.$id]: item,
    };
  }

  get items() {
    return this.cachedDrugGroups;
  }
}
